export enum SnapshotFormat {
    RawObject = 'object',
    JSON = 'json',
    Zlib = 'zlib', // object -> json -> zlib
}
